import React, { useState, useEffect } from 'react';
import {
  Card,
  CardBody,
  Button,
  ButtonGroup,
  Form,
  CustomInput,
  FormGroup,
  Input,
} from 'reactstrap';
import IntlMessages from '../../../../../../helpers/IntlMessages';
import { Separator, Colxx } from '../../../../../../components/common/CustomBootstrap';
import Tooltip from '../Tooltip';
import { size } from 'lodash';

let arr = [];
export default function IntegrationInfo({
  integration,
  integrationProperties,
  allProperties,
  saveIntegration,
}) {
  const [formatedProperties, setFormatedProperties] = useState([]);
  const [isEditing, setIsEditing] = useState(false);
  const [list, setList] = useState([]);
  const [name, setName] = useState('');
  const [propertyList, setPropertyList] = useState([]);

  useEffect(() => {
    const result = integrationProperties.map(id => {
      return allProperties.find(elem => elem.id === id);
    });
    setFormatedProperties(result);
    setList(integrationProperties);
    if (integration.name !== undefined && integration.name !== null) {
      setName(integration.name);
    }
    const property = allProperties?.map((elem) => {
      elem.checked = false;
      result.forEach((lang) => {
        if (lang.id === elem.id) {
          elem.checked = true;
        }
      });
      return elem;
    });
    setPropertyList(property);
  }, [integrationProperties, allProperties]);


  const handleCheckChange = (e) => {
    if (e.target.checked) {
      setList([e.target.value]);
    }
    if (!e.target.checked) {
      setList([]);
    }
  };

  const handleSave = () => {
    saveIntegration({ list, name });
    arr = [];
    setList([]);
    setIsEditing(!isEditing);
  };

  const handleNameChange = e => {
    setName(e.target.value);
  };

  const groupName = formatedProperties?.[0]?.groupName != null && formatedProperties?.[0]?.groupName != undefined ? formatedProperties[0].groupName : '';
  const styles = `
  .integration-title {
  color: #777 !important;
  }
  `;

  const Show = () => {
    return (
      <>
        <style>{styles}</style>
        <CardBody>
          <div className="text-center">
            <h6>
              <IntlMessages id='integration.select_properties' />
            </h6>
            <Separator className="mb-3" />
            <Card className="m-4">
              <Colxx xxs="12" className="p-4">
                <h1 className="integration-title p-0">{integration ? integration.name : null}</h1>
                <div className="mb-3">
                  <h6>Integration</h6>
                  <div className="mb-2 container">
                    <b>{integration ? integration.name : null} </b>
                    <span className="text-muted pl-1">
                      ({integration ? integration.id : null})
                    </span>
                    {integration?.id &&
                      <div
                        style={{ cursor: 'pointer', marginLeft: 5, color: 'grey' }}
                        onClick={() => {
                          navigator.clipboard.writeText(integration.id);
                        }}
                      >
                        {' '}
                        <i className='iconsminds-file-copy'></i>
                      </div>
                    }
                  </div>
                </div>
                <div className='mb-3'>
                  <h6>Group</h6>
                  <div className="mb-2 container">
                    <b> {groupName}  </b>{' '}
                    <span className="text-muted pl-1">
                      ({integration ? integration.groupId : null})
                    </span>
                    {integration?.groupId &&
                      <div
                        style={{ cursor: 'pointer', marginLeft: 5, color: 'grey' }}
                        onClick={() => {
                          navigator.clipboard.writeText(integration.groupId);
                        }}
                      >
                        {' '}
                        <i className='iconsminds-file-copy'></i>
                      </div>
                    }
                  </div>
                </div>
                <div className="mb-3">
                  <h6>Business</h6>
                  <div className="mb-2">
                    {formatedProperties
                      ? formatedProperties.map((elem, index) => {
                        return (
                          <div key={index} className="mb-2 container">
                            <b>{elem ? elem?.name : null}</b>{' '}
                            <span className="text-muted pl-1">
                              ({elem ? elem.id : null})
                            </span>
                            {elem?.id &&
                              <div
                                style={{ cursor: 'pointer', marginLeft: 5, color: 'grey' }}
                                onClick={() => {
                                  navigator.clipboard.writeText(elem?.id);
                                }}
                              >
                                {' '}
                                <i className='iconsminds-file-copy'></i>
                              </div>
                            }
                          </div>
                        );
                      })
                      : null}
                  </div>
                </div>
              </Colxx>
            </Card>
            <Separator className="my-3" />
            <Button
              size="xs"
              color="success"
              outline
              className="my-2 text-center"
              onClick={() => setIsEditing(!isEditing)}
            >
              Edit
            </Button>
          </div>
        </CardBody>
      </>
    );
  };

  const Edit = () => {
    return (
      <CardBody>
        <div className="text-center">
          <h6>
            Integration Information{' '}
            {/* <Tooltip
              item={{
                text: '?',
                body:
                  'Integration allows you to select the chat widget appearance, choose properties, and generate code to publish your digital assistant on your website.',
              }}
              id={integration.id}
            /> */}
          </h6>
          <Separator className="mb-3" />
          <Card className="m-4">
            <Colxx xxs="12" className="p-4">
              <div className="text-left">
                <div className="mb-3 text-left">
                  <h6>Integration Name</h6>
                  <Input
                    className="form-control"
                    name="name"
                    defaultValue={integration.name}
                    onChange={handleNameChange}
                  />
                </div>
                <div className='mb-3'>
                  <h6>Group</h6>
                  <span className="text-muted">
                    {integration ? integration.groupId : null}
                  </span>
                </div>
                <div>
                  <Form>
                    <h6>Businesses</h6>
                    <div className='integration-property mt-3'>
                      {propertyList.map((p, index) => {
                        return (
                          <CustomInput
                            key={p.id}
                            type="radio"
                            id={index}
                            label={p.name}
                            value={p.id}
                            checked={p.id === list[0] ? true : false}
                            onChange={handleCheckChange}
                          />
                        );
                      })}
                    </div>
                  </Form>
                </div>
              </div>
            </Colxx>
          </Card>
          <Separator className="my-3"></Separator>
          <div className="mb-2 text-center">
            <Button className='mr-1' color="primary" size="xs" onClick={handleSave}>
              Save
            </Button>
            <Button className='ml-1' color="secondary" size="xs" onClick={() => setIsEditing(!isEditing)}            >
              Cancel
            </Button>
          </div>
        </div>
      </CardBody >
    );
  };

  return <Card className="mb-4">{isEditing ? Edit() : Show()}</Card>;
}
